import {
  CartShipToHomeType,
  CartLineItem,
} from '@adapters/bigcommerce/types/cart';
import { Cart } from '@adapters/bigcommerce/types/cart';
import { RESTRICTION_LEVELS } from '@utils/shipping/constants';
import { canShipToAddress } from '@utils/fulfillment';

export const getCartShipToHomeType = (
  cart: Cart | null
): CartShipToHomeType => {
  if (!cart?.cartData?.line_items?.physical_items) {
    return CartShipToHomeType.REGULAR;
  }

  // Items that can't ship (e.g. pickup-only) don't set the shipping type, so
  // they don't add an oversize surcharge to everyone else's estimate.
  const physicalItems = cart.cartData.line_items.physical_items.filter(
    (item: CartLineItem) =>
      !item.removedMessage &&
      canShipToAddress(item.fulfillment_restriction, item.shipping_restrictions)
  );

  if (physicalItems.length === 0) {
    return CartShipToHomeType.REGULAR;
  }

  const bikeItems = physicalItems.filter(
    (item: CartLineItem) =>
      item.shipping_restrictions?.restriction_level ===
      RESTRICTION_LEVELS.BIKE_ONLY
  );

  const nonBikeItems = physicalItems.filter(
    (item: CartLineItem) =>
      item.shipping_restrictions?.restriction_level !==
      RESTRICTION_LEVELS.BIKE_ONLY
  );

  const surchargeItems = physicalItems.filter(
    (item: CartLineItem) =>
      item.shipping_restrictions?.restriction_level ===
        RESTRICTION_LEVELS.OVER_SIZE_R5 ||
      item.shipping_restrictions?.restriction_level ===
        RESTRICTION_LEVELS.OVER_SIZE_R2
  );

  const groundOnlyItems = physicalItems.filter(
    (item: CartLineItem) =>
      item.shipping_restrictions?.restriction_level ===
      RESTRICTION_LEVELS.GROUND_ONLY
  );

  // If cart has both bike and non-bike items, it's multicarrier
  if (bikeItems.length > 0 && nonBikeItems.length > 0) {
    return CartShipToHomeType.MULTICARRIER;
  }

  // If cart has only bike items
  if (bikeItems.length > 0 && nonBikeItems.length === 0) {
    return CartShipToHomeType.BIKE_ONLY;
  }

  if (surchargeItems.length > 0) {
    return CartShipToHomeType.OVER_SIZE_SURCHARGE;
  }

  // If cart has only non-bike items
  if (groundOnlyItems.length > 0) {
    return CartShipToHomeType.GROUND_ONLY;
  }

  return CartShipToHomeType.REGULAR;
};
